export let SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
  return SortOrder;
}({});
export const sortByCreatedDate = function (entities, order) {
  if (order === void 0) {
    order = SortOrder.ASC;
  }
  return [...entities].sort((a, b) => {
    if (!a.createdDate) return 1;
    if (!b.createdDate) return -1;
    const dateA = new Date(a.createdDate).getTime();
    const dateB = new Date(b.createdDate).getTime();
    return order === SortOrder.ASC ? dateA - dateB : dateB - dateA;
  });
};
//# sourceMappingURL=time.js.map